import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SecurityService } from '../../../../core/security/security.service';
import { AuditHistoryVm } from '../../../../shared/generated/Models/AuditHistoryVm';
import { NavigationService } from '../../../../shared/navigation/navigation.service';
import { TableComponent } from '../../../../shared/table/table.component';

@Component({
    selector: 'pcg-user-audit-history',
    templateUrl: './user-audit-history.component.html',
    styleUrls: ['./user-audit-history.component.scss'],
    standalone: false,
})
export class UserAuditHistoryComponent implements OnInit {
    @ViewChild(TableComponent, { static: true }) table!: TableComponent<AuditHistoryVm>;

    @Input() id = 0;

    columns = AuditHistoryVm.ColumnDefs;
    canEditUser = false;
    fullName: string = null!;
    filters = { userId: this.id };

    constructor(
        private activatedRoute: ActivatedRoute,
        private sec: SecurityService,
        private nav: NavigationService
    ) {}

    ngOnInit() {
        this.filters.userId = this.activatedRoute.snapshot.params['id'];
        this.canEditUser = this.sec.hasAccess((o) => o.manageUsers);
        this.setSecondaryNav();
    }

    /** Set the navigation that sits under the main navigation */
    setSecondaryNav() {
        if (this.sec.hasAccess((o) => o.manageUsers)) {
            this.nav.setOpenSecondaryMenu(['Admin', 'Users', 'User List']);
        }
    }
}
